import { PhoneNumberCountryStatus } from 'src/lib/fliko/helpers/phone-number.helper';
import { ToString } from 'src/lib/fliko/helpers/toString.helper';
import { EstateType } from 'src/lib/fliko/models/estate/estate.data';
import { DataTableColumn, LocLabelModifier } from 'src/app/shared/components/clickable-row-table/models/data-table-config.models';
import {
  ValueCheckboxTable,
  ValuePhoneNumberTable,
  ValueRentalUnitAdrTable,
  ValueStringLocalizedTable,
  ValueStringTable
} from 'src/app/shared/components/clickable-row-table/models/value-table.model';
import { GrammarHelper } from 'src/app/shared/helpers/grammar.helper';
import { sort } from 'src/app/shared/helpers/table.constants';
import { ResidentUnitsVM } from 'src/app/view/users/services/models/users-view-models';
import { ReceiverSelectDisplayMode } from './receivers-select.view-model';

export interface ReceiversTableRowsBase {
  id: ValueStringTable;
  checkbox: ValueCheckboxTable;
  fullName: ValueStringTable;
  type: ValueStringLocalizedTable;
  address: ValueRentalUnitAdrTable;
}

export interface ReceiversTableRows extends ReceiversTableRowsBase {
  email: ValueStringTable;
  phone: ValuePhoneNumberTable;
  phoneStatus: ValueStringLocalizedTable;
}

export function receiversTableColumns(displayMode: ReceiverSelectDisplayMode): DataTableColumn[] {
  return [
    { name: { key: ''                     }, value: 'checkbox'          },
    { name: { key: 'user.nameSurname'     }, value: 'fullName',    sort },
    { name: { key: 'user.residentType'    }, value: 'type',        sort },
    { name: { key: `label.${displayMode}` }, value: displayMode,   sort },
    ...( displayMode === 'phone'
?  [{ name: { key: 'label.status'         }, value: 'phoneStatus', sort }]
:  []),
    { name: { key: 'label.address'        }, value: 'address',     sort }
  ]; // prettier-ignore
}

export function residentUnitVMToTableRows(
  data: ResidentUnitsVM[],
  onClick: (id: string, value: boolean) => void,
  estateType: EstateType,
  selected: Set<string>,
  phoneStatuses: ReadonlyMap<string, PhoneNumberCountryStatus> = new Map()
): ReceiversTableRows[] {
  return data.map((d) => {
    const phoneStatus = phoneStatuses.get(d.resident.id) ?? 'allowed';
    const phoneUnavailable = phoneStatus !== 'allowed';
    const phone = new ValuePhoneNumberTable(ToString.getPhone(d.resident));
    if (phoneUnavailable) phone.className = 'foreground yellow-darker';

    return {
      id: new ValueStringTable(d.resident.id),
      checkbox: new ValueCheckboxTable(
        d.resident.id,
        onClick,
        selected.has(d.resident.id) && !phoneUnavailable,
        phoneUnavailable
      ),
      address: new ValueRentalUnitAdrTable(d.units, true),
      type: new ValueStringLocalizedTable(
        GrammarHelper.getResidentKeyInCase(estateType, d.type, 'M'),
        undefined,
        LocLabelModifier.CAP
      ),
      email: new ValueStringTable(ToString.getEmail(d.resident)),
      phone,
      phoneStatus: new ValueStringLocalizedTable(
        getPhoneStatusKey(phoneStatus),
        undefined,
        undefined,
        phoneUnavailable ? 'foreground yellow-darker' : undefined
      ),
      fullName: new ValueStringTable(ToString.fullName(d.resident))
    };
  });
}

/** @param status */
function getPhoneStatusKey(status: PhoneNumberCountryStatus): string {
  if (status === 'foreign') return 'select.foreignPhoneNumberUnavailable';
  if (status === 'invalid') return 'select.invalidPhoneNumberUnavailable';
  return '';
}
